import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import { useHome } from '../context/HomeContext';
import { API_CONFIG } from '../config/apiConfig';

const TrendingProducts = () => {
  const [activeTab, setActiveTab] = useState('all');
  const { homeData, loading, error } = useHome();

  const products = homeData?.topProducts || [];

  // Build tabs: 'All' + all subcategories from all main categories (using subCates)
  let subcategories = [];
  if (Array.isArray(homeData.categories)) {
    homeData.categories.forEach(cat => {
      if (Array.isArray(cat.subCates)) {
        cat.subCates.forEach(sub => {
          subcategories.push({ id: String(sub.id), label: sub.name });
        });
      }
    });
  }
  // Remove duplicates by id
  const uniqueSubcategories = Object.values(
    subcategories.reduce((acc, sub) => {
      acc[sub.id] = sub;
      return acc;
    }, {})
  );
  const tabs = [
    { id: 'all', label: 'All' },
    ...uniqueSubcategories
  ];

  // Filter products by selected subcategory tab
  const filteredProducts = products.filter(product => {
    if (activeTab === 'all') return true;
    // Match product.subCate_id or product.cate_id to tab id
    return String(product.subCate_id) === activeTab || String(product.cate_id) === activeTab;
  });

  return (
    <section className="product__section section--padding pt-0">
      <div className="container">
        <div className="section__heading text-center mb-25">
          <span className="section__heading--subtitle">Recently added our store</span>
          <h2 className="section__heading--maintitle">Trending Products</h2>
        </div>
        
        <ul className="product__tab--one product__tab--btn d-flex justify-content-center mb-35">
          {tabs.map((tab) => (
            <li 
              key={tab.id}
              className={`product__tab--btn__list ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </li>
          ))}
        </ul>

        <div className="tab_content">
          <div className={`tab_pane ${activeTab ? 'active show' : ''}`}>
            <div className="product__section--inner">
              <div className="row row-cols-lg-4 row-cols-md-3 row-cols-2 mb--n28">
                {filteredProducts.map((product) => (
                  <div key={product.id} className="col mb-28">
                    <ProductCard product={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrendingProducts;
